var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.981,
    height: 17.983,
    viewBox: "0 0 19.981 17.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "workspaces_FILL1_wght400_GRAD0_opsz24",
    d: "M84-822.017a3.848,3.848,0,0,1-2.822-1.174A3.848,3.848,0,0,1,80-826.013a3.848,3.848,0,0,1,1.174-2.822A3.848,3.848,0,0,1,84-830.009a3.848,3.848,0,0,1,2.822,1.174,3.848,3.848,0,0,1,1.174,2.822,3.848,3.848,0,0,1-1.174,2.822A3.848,3.848,0,0,1,84-822.017Zm11.989,0a3.848,3.848,0,0,1-2.822-1.174,3.848,3.848,0,0,1-1.174-2.822,3.848,3.848,0,0,1,1.174-2.822,3.848,3.848,0,0,1,2.822-1.174,3.848,3.848,0,0,1,2.822,1.174,3.848,3.848,0,0,1,1.174,2.822,3.848,3.848,0,0,1-1.174,2.822A3.848,3.848,0,0,1,95.985-822.017Zm-5.994-9.991a3.848,3.848,0,0,1-2.822-1.174A3.848,3.848,0,0,1,85.994-836a3.848,3.848,0,0,1,1.174-2.822A3.848,3.848,0,0,1,89.991-840a3.848,3.848,0,0,1,2.822,1.174A3.848,3.848,0,0,1,93.987-836a3.848,3.848,0,0,1-1.174,2.822A3.848,3.848,0,0,1,89.991-832.008Z",
    transform: "translate(-80 840)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.55887eebdf8597b54cad92f26e986aee.svg";
export { ForwardRef as ReactComponent };